import React from "react";
import { Modal } from "react-bootstrap";
import "../../css/rentals/rentals.css";

class RentalDeliveryConfirmModal extends React.Component {
  render() {
    const {
      show,
      rental,
      isLoading,
      onClose,
      onConfirm,
    } = this.props;

    if (!show || !rental) return null;

    const productName = rental.product_name || (rental.product ? rental.product.designation : "Produit");

    return (
      <Modal
        show={show}
        onHide={onClose}
        backdrop={isLoading ? "static" : true}
        keyboard={!isLoading}
        centered
        size="md"
        className="rental-delivery-confirm-modal"
        dialogClassName="modal-dialog-rounded"
      >
        <Modal.Header style={{ backgroundColor: '#ffc107', color: '#212529', borderTopLeftRadius: '0.5rem', borderTopRightRadius: '0.5rem' }}>
          <Modal.Title className="rental-modal-title">
            Confirmer la livraison
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="rental-modal-body">
          <div className="rental-modal-body-inner">
            <h5 className="rental-modal-product-name">
              Marquer comme livré
            </h5>
            <p className="rental-modal-form-hint">
              Êtes-vous sûr de vouloir marquer la location de <strong>{productName}</strong> comme livrée ?
            </p>
            <p className="rental-modal-form-hint">
              La location passera au statut <strong className="text-success">Actif</strong>.
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="rental-modal-footer" style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="btn btn-secondary"
            style={{ flex: 1 }}
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="btn btn-warning"
            style={{ flex: 1 }}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <span> Confirmation en cours...</span>
              </>
            ) : (
              "Confirmer la livraison"
            )}
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RentalDeliveryConfirmModal;
